import React from "react";
import { catalogCardSx } from "../components/catalogStyles";
import { Box, Typography, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import { ToolDefinition } from "./toolDefinitions";

interface ToolItemProps {
  tool: ToolDefinition;
  to: string;
}

export function ToolItem({ tool, to }: ToolItemProps) {
  const theme = useTheme();

  return (
    <Box
      component={Link}
      to={to}
      className="site-motion"
      data-testid="tool-card"
      sx={{
        ...catalogCardSx(theme),
        display: "flex",
        alignItems: "center",
        gap: 2,
        padding: 2.5
      }}
    >
      <Box
        sx={{
          width: "44px",
          height: "44px",
          borderRadius: "10px",
          background: `linear-gradient(135deg, ${theme.palette.accent2}, ${theme.palette.accent3})`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "1.2rem",
          flexShrink: 0
        }}
      >
        {tool.icon ?? "\uD83D\uDD27"}
      </Box>
      <Box sx={{ minWidth: 0, overflowWrap: "anywhere" }}>
        <Typography sx={{ fontSize: "1rem", fontWeight: 500 }}>
          {tool.title}
        </Typography>
        <Typography sx={{ fontSize: "0.875rem", color: theme.palette.textDim }}>
          {tool.desc ?? ""}
        </Typography>
      </Box>
    </Box>
  );
}
